import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 1350,
  height: 760,
  x: 50,
  y: 50,
  list: [
    {
      id: "e581810b-8399-4124-93a0-fc1319100c21",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "2f1fbd2f-6fb8-41cc-be8c-a1e3c2b31fa3",
      type: "Graphics",
      name: "ovelay",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "e581810b-8399-4124-93a0-fc1319100c21",
      bake: false,
      commands: [],
      data: ""
    },
    {
      id: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      type: "Container",
      name: "wheelContainer",
      nameSpace: "",
      className: "",
      x: -313,
      y: 39,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "e581810b-8399-4124-93a0-fc1319100c21",
      data: ""
    },
    {
      id: "73db4ea3-3ba9-4bb9-bb1f-59c6c7020b98",
      type: "Container",
      name: "panelContainer",
      nameSpace: "",
      className: "",
      x: 322,
      y: 22,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "e581810b-8399-4124-93a0-fc1319100c21",
      data: ""
    },
    {
      id: "8d154a90-baeb-4130-b72c-61ec5272ded2",
      type: "Container",
      name: "haloContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      data: ""
    },
    {
      id: "3391658d-2777-4e7b-8661-e6dd3892b86e",
      type: "Container",
      name: "haloWinContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      data: ""
    },
    {
      id: "f99bf9a4-7931-4552-94d7-f761d207e4a7",
      type: "Container",
      name: "wheelPrizes",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      data: ""
    },
    {
      id: "f5135204-0542-49c0-ab5d-374752f983a9",
      type: "Sprite",
      name: "wheelMultipliers",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wheel_multipliers",
      parent: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      data: ""
    },
    {
      id: "18463b49-ca3d-4c6f-aa74-0092df308527",
      type: "Container",
      name: "sectorLightUpContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      data: ""
    },
    {
      id: "e12e6c2c-d7d2-4fdf-b0a0-0962fdea3090",
      type: "Container",
      name: "wheelBaseContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      data: ""
    },
    {
      id: "b2c854d8-7578-43f1-a970-7afc4c8f4cbc",
      type: "Container",
      name: "sectorParticleContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      data: ""
    },
    {
      id: "7a4240d1-8776-4747-a622-4a98ffe35270",
      type: "Sprite",
      name: "multiplierPanel",
      nameSpace: "",
      className: "",
      x: 0,
      y: -348,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wheel_top_board",
      parent: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      data: ""
    },
    {
      id: "d045f827-6393-4649-be3a-4eeff0d3bda8",
      type: "Sprite",
      name: "bigWheelPointer",
      nameSpace: "",
      className: "",
      x: 0,
      y: -294,
      anchor: {
        x: 0.5,
        y: 0.36
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wheel_arrow_1",
      parent: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      data: ""
    },
    {
      id: "a10d6d92-301b-4c21-9dde-1d4a4035f550",
      type: "Sprite",
      name: "smallWheelPointer",
      nameSpace: "",
      className: "",
      x: 0,
      y: -117,
      anchor: {
        x: 0.5,
        y: 0.36
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wheel_arrow_2",
      parent: "ad784f41-f3c0-41b7-9491-bd3276f95ed6",
      data: ""
    },
    {
      id: "dc4b12ca-8b37-4001-9af9-4ce154221033",
      type: "Sprite",
      name: "spinPanel",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wheel_ui_window",
      parent: "73db4ea3-3ba9-4bb9-bb1f-59c6c7020b98",
      data: ""
    },
    {
      id: "74d603b6-2056-48bf-b025-cfeecbb5e8b4",
      type: "Sprite",
      name: "sharePanel",
      nameSpace: "",
      className: "",
      x: 0,
      y: 18,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wheel_ui_window_share",
      parent: "73db4ea3-3ba9-4bb9-bb1f-59c6c7020b98",
      data: ""
    },
    {
      id: "fd0174af-39c0-4602-8307-7f5c38431c47",
      type: "Container",
      name: "titleContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: -116,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "73db4ea3-3ba9-4bb9-bb1f-59c6c7020b98",
      data: ""
    },
    {
      id: "b89b450a-072c-43ed-9da2-a92a84d9047e",
      type: "Container",
      name: "sectorsContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "f99bf9a4-7931-4552-94d7-f761d207e4a7",
      data: ""
    },
    {
      id: "1bd19f32-9125-4fb5-888a-9770ba22c67e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "wheel_rail",
      parent: "f99bf9a4-7931-4552-94d7-f761d207e4a7",
      data: ""
    },
    {
      id: "3f4ddb76-9b60-40c6-b4bf-aae3cb32d1bd",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "multipliers",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.14
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x3",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#BC5604",
        stroke: "#FFF72A",
        strokeThickness: 2,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "f5135204-0542-49c0-ab5d-374752f983a9",
      data: ""
    },
    {
      id: "b17ee6aa-848a-4dab-ba3b-ad432eed0d3c",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "multipliers",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.14
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 45,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x3",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#BC5604",
        stroke: "#FFF72A",
        strokeThickness: 2,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "f5135204-0542-49c0-ab5d-374752f983a9",
      data: ""
    },
    {
      id: "a377cea5-812c-4655-97a2-9ca2aafdbe15",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "multipliers",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.14
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 90,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x3",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#BC5604",
        stroke: "#FFF72A",
        strokeThickness: 2,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "f5135204-0542-49c0-ab5d-374752f983a9",
      data: ""
    },
    {
      id: "4d423b4f-6783-4d88-92a8-d03b9127c92c",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "multipliers",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.14
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 135,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x3",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#BC5604",
        stroke: "#FFF72A",
        strokeThickness: 2,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "f5135204-0542-49c0-ab5d-374752f983a9",
      data: ""
    },
    {
      id: "911965ea-7cee-47c1-b507-6af0d42eec80",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "multipliers",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.14
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x3",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#BC5604",
        stroke: "#FFF72A",
        strokeThickness: 2,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "f5135204-0542-49c0-ab5d-374752f983a9",
      data: ""
    },
    {
      id: "ce9df7f7-431c-43f7-bcbc-c377464a5800",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "multipliers",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.14
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 225,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x3",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#BC5604",
        stroke: "#FFF72A",
        strokeThickness: 2,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "f5135204-0542-49c0-ab5d-374752f983a9",
      data: ""
    },
    {
      id: "a73195b6-99c3-4e9f-aec6-2f4e44855aa3",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "multipliers",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.14
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 270,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x3",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#BC5604",
        stroke: "#FFF72A",
        strokeThickness: 2,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "f5135204-0542-49c0-ab5d-374752f983a9",
      data: ""
    },
    {
      id: "440e3c59-4241-42fe-896e-bf987371a0dc",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "multipliers",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.14
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 315,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x3",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#BC5604",
        stroke: "#FFF72A",
        strokeThickness: 2,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "f5135204-0542-49c0-ab5d-374752f983a9",
      data: ""
    },
    {
      id: "3d71c7fa-3e2a-41dd-b2c6-ecf9f5057de6",
      type: "Text",
      name: "multiplierText",
      nameSpace: "",
      className: "",
      x: 3,
      y: -22,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "X3",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "black",
        stroke: "#601809",
        strokeThickness: 4,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 5
      },
      parent: "7a4240d1-8776-4747-a622-4a98ffe35270",
      data: ""
    },
    {
      id: "a1dbe677-3bb0-431f-a55c-224542cea5b2",
      type: "Text",
      name: "spinToWinText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "SpinToWin",
      localize: true,
      maxWidth: 475,
      maxHeight: 67,
      maxFontSize: 44,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffffff",
        stroke: "#601809",
        strokeThickness: 4,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "dc4b12ca-8b37-4001-9af9-4ce154221033",
      data: ""
    },
    {
      id: "1808b9c6-95e7-4209-aca6-0319c50615ef",
      type: "Container",
      name: "spinButtonContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 109,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "dc4b12ca-8b37-4001-9af9-4ce154221033",
      data: ""
    },
    {
      id: "ee8dd272-2044-432f-84d4-8def2e871d0f",
      type: "Container",
      name: "stopButtonContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 109,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "dc4b12ca-8b37-4001-9af9-4ce154221033",
      data: ""
    },
    {
      id: "94c883b0-61f6-4366-b49f-ff59e334a94a",
      type: "Container",
      name: "shareButtonContainer",
      nameSpace: "",
      className: "",
      x: 150,
      y: 135,
      scale: {
        x: 0.84,
        y: 0.84
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "74d603b6-2056-48bf-b025-cfeecbb5e8b4",
      data: ""
    },
    {
      id: "c897e03b-a8c4-4e69-9704-02c50141f638",
      type: "Container",
      name: "claimButtonContainer",
      nameSpace: "",
      className: "",
      x: -101,
      y: 135,
      scale: {
        x: 1.25,
        y: 1.25
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "74d603b6-2056-48bf-b025-cfeecbb5e8b4",
      data: ""
    },
    {
      id: "47da941d-8498-4962-a4ee-b5de0d26cd94",
      type: "Container",
      name: "rewardContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: -5,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "74d603b6-2056-48bf-b025-cfeecbb5e8b4",
      data: ""
    },
    {
      id: "8b6b44d0-5f45-4ef7-9e90-0631abf836c1",
      type: "Sprite",
      name: "spinButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_play",
      parent: "1808b9c6-95e7-4209-aca6-0319c50615ef",
      data: ""
    },
    {
      id: "ba7782af-883f-408e-8c31-a7ae3761dc7e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "gold_frame_button",
      parent: "1808b9c6-95e7-4209-aca6-0319c50615ef",
      data: ""
    },
    {
      id: "087394e1-fb75-4e08-966d-9d9683ef66ee",
      type: "Sprite",
      name: "stopButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_stop",
      parent: "ee8dd272-2044-432f-84d4-8def2e871d0f",
      data: ""
    },
    {
      id: "c65c7cc1-4219-4ff1-88b4-540c95005f13",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "gold_frame_button",
      parent: "ee8dd272-2044-432f-84d4-8def2e871d0f",
      data: ""
    },
    {
      id: "dfbf3460-cc27-4beb-9008-90b6baabbf79",
      type: "Sprite",
      name: "shareButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_share",
      parent: "94c883b0-61f6-4366-b49f-ff59e334a94a",
      data: ""
    },
    {
      id: "cde0e44e-9608-45d9-a018-261deab1433c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "gold_frame_button_small",
      parent: "94c883b0-61f6-4366-b49f-ff59e334a94a",
      data: ""
    },
    {
      id: "b0144059-8d92-41ee-9eaa-395d91f84bae",
      type: "Sprite",
      name: "claimButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_claimreward",
      parent: "c897e03b-a8c4-4e69-9704-02c50141f638",
      data: ""
    },
    {
      id: "1b19a0d0-13ca-42d7-9719-3e8e37856f70",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "gold_frame_button_small",
      parent: "c897e03b-a8c4-4e69-9704-02c50141f638",
      data: ""
    },
    {
      id: "70e4013d-e2ea-426a-9c75-4ccd1da59b36",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "FreeSpin2",
      localize: true,
      maxWidth: 233,
      maxHeight: 89,
      maxFontSize: 52,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#13742B",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "8b6b44d0-5f45-4ef7-9e90-0631abf836c1",
      data: ""
    },
    {
      id: "9d4a1f7e-33cc-43b9-9e82-a0cfdc9f39a6",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Stop",
      localize: true,
      maxWidth: 233,
      maxHeight: 89,
      maxFontSize: 52,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#97242D",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "087394e1-fb75-4e08-966d-9d9683ef66ee",
      data: ""
    },
    {
      id: "3d821539-6e3c-40ad-bac7-1f430453bb42",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Share",
      localize: true,
      maxWidth: 178,
      maxHeight: 49,
      maxFontSize: 32,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#00386E",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "dfbf3460-cc27-4beb-9008-90b6baabbf79",
      data: ""
    },
    {
      id: "544eec70-140e-43a8-8704-80d1279059b5",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "ClaimReward",
      localize: true,
      maxWidth: 223,
      maxHeight: 61,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#13742B",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "b0144059-8d92-41ee-9eaa-395d91f84bae",
      data: ""
    }
  ]
} as const;

export class StandardWheelLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  ovelay: GameObject<PIXI.Graphics>;
  wheelContainer: GameObject<PIXI.Container>;
  haloContainer: GameObject<PIXI.Container>;
  haloWinContainer: GameObject<PIXI.Container>;
  wheelPrizes: GameObject<PIXI.Container>;
  sectorsContainer: GameObject<PIXI.Container>;
  wheelMultipliers: GameObject<PIXI.Sprite>;
  sectorLightUpContainer: GameObject<PIXI.Container>;
  wheelBaseContainer: GameObject<PIXI.Container>;
  sectorParticleContainer: GameObject<PIXI.Container>;
  multiplierPanel: GameObject<PIXI.Sprite>;
  multiplierText: GameObject<PIXI.Text>;
  bigWheelPointer: GameObject<PIXI.Sprite>;
  smallWheelPointer: GameObject<PIXI.Sprite>;
  panelContainer: GameObject<PIXI.Container>;
  spinPanel: GameObject<PIXI.Sprite>;
  spinToWinText: GameObject<PIXI.Text>;
  spinButtonContainer: GameObject<PIXI.Container>;
  spinButton: GameObject<PIXI.Sprite>;
  stopButtonContainer: GameObject<PIXI.Container>;
  stopButton: GameObject<PIXI.Sprite>;
  sharePanel: GameObject<PIXI.Sprite>;
  shareButtonContainer: GameObject<PIXI.Container>;
  shareButton: GameObject<PIXI.Sprite>;
  claimButtonContainer: GameObject<PIXI.Container>;
  claimButton: GameObject<PIXI.Sprite>;
  rewardContainer: GameObject<PIXI.Container>;
  titleContainer: GameObject<PIXI.Container>;
  multipliers: (GameObject<PIXI.Text>)[];

  constructor() {
    populate(this, raw);
  }
}
